import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Benefits from "@/components/Benefits";
import BeforeAfter from "@/components/BeforeAfter";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import FloatingMenu from "@/components/FloatingMenu";

export default function Landing() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#050505] text-[#FAFAFA]">
      <Navbar />
      <Hero onOpenChat={() => setChatOpen(true)} />
      <Services />
      <Benefits />
      <BeforeAfter />
      <Footer />
      <FloatingMenu onOpenChat={() => setChatOpen(true)} chatOpen={chatOpen} />
      <ChatWidget open={chatOpen} onOpenChange={setChatOpen} />
    </div>
  );
}
